/**
* 状态管理仓库
*/
import Vue from 'vue'
import Vuex from 'vuex'

// 模块

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
  }
})

export default store



// WEBPACK FOOTER //
// ./src/stores/index.js